module.exports = __webpack_public_path__ + "img/02.b80431f2.png";